export enum CustomListFieldDefinitionTypeEnum {
  Text = 'text',
  StyledText = 'html',
  Image = 'image',
  Link = 'link',
  Boolean = 'boolean',
  Enum = 'enum'
}
